import { render, staticRenderFns } from "./MainView.html?vue&type=template&id=229377a4&scoped=true&"
import script from "./MainView.js?vue&type=script&lang=js&"
export * from "./MainView.js?vue&type=script&lang=js&"
import style0 from "./MainView.scss?vue&type=style&index=0&id=229377a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229377a4",
  null
  
)

component.options.__file = "MainView.vue"
export default component.exports